import gql from 'graphql-tag';

export default gql`
fragment ProductAllData on Product {
    id
    ext_id
    previous_id
    name
    status
    url_key
    smarturl
    categories {
        id
        name
    }
    default_category_id
    price
    price_unit
    price_per_unit
    unit_price
    special_unit_price
    personal_discount_price
    personal_discount_unit_price
    vat
    special_price
    special_from_date
    special_to_date
    news_from_date
    news_to_date
    vote_calculated {
        vote_avg
        vote_count_one
        vote_count_two
        vote_count_three
        vote_count_four
        vote_count_five
    }
    description
    components
    nutrition_data
    prefixbox_score
    barcodes
    alternative_quantity_name
    alternative_quantity_minimum
    alternative_quantity_scale
    alternative_quantity_exchange_rate
    default_quantity_name
    default_quantity_minimum
    default_quantity_scale
    is_qty_decimal
    gift_message_available
    is_mpl
    meta_title
    meta_description
    meta_keywords
    min_expiry_days
    package_official_g
    package_official_ml
    sliceable
    weight
    attributes {
        id
        name
        options {
            id
            label
        }
    }
    images {
        id
        is_default
        url
        conversions {
            thumbnail
            list
            full
        }
    }
    is_subscribed
    created_at
    updated_at
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/fragments/ProductAllData.ts